import graphql__ac22d1f66c2c6f3df129 from "./__generated__/useVoteButtonsLabel_votable.graphql.js";import { useMemo, useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { useRemainingVotesScreenReaderLabel } from "./VoteButton";
import { useFormatMessage } from "../Intl/Context";

export const useVoteButtonsLabel = props => {
  const votable = useFragment(useVoteButtonsLabel_votable, props.votable);
  const { currentViewerVote, singleVoteMode, votesMode } = votable;

  const { voteType, intlMessages } = props;

  const remainingVotesMessage = useRemainingVotesScreenReaderLabel({ votable });

  const isActive = currentViewerVote === voteType;
  const isLikesMode = votesMode === "LIKES";

  const t = useFormatMessage();

  const labelFor = useCallback(
    key => {
      if (isLikesMode) {
        return intlMessages[key.replace("label", "likeLabel")];
      } else {
        return intlMessages[key];
      }
    },
    [intlMessages, isLikesMode]
  );

  const labelActive = labelFor("labelActive");
  const labelAdd = labelFor("labelAdd", { remainingVotesMessage });
  const labelDefault = labelFor("label", { remainingVotesMessage });
  const votesCountScreenReaderLabel = labelFor("votesCountScreenReaderLabel");

  const label = useMemo(() => {
    if (isActive && singleVoteMode) {
      return t(labelActive);
    } else if (isActive) {
      return t(labelAdd, { remainingVotesMessage });
    }

    return t(labelDefault, { remainingVotesMessage });
  }, [
    isActive,
    singleVoteMode,
    t,
    remainingVotesMessage,
    labelActive,
    labelAdd,
    labelDefault
  ]);

  return { label, votesCountScreenReaderLabel };
};

const useVoteButtonsLabel_votable = graphql__ac22d1f66c2c6f3df129;
